import React, { Component } from 'react';
import { connect } from 'react-redux';
import ExcelBulkEditProductDiscountFailModal from '../../../../views/product/common/modal/ExcelBulkEditProductDiscountFailModal';
import withModal from '../../../../lib/hoc/withModal';
import { productActions } from '../../../../store/modules/product';

class ExcelBulkEditProductDiscountFailModalContainer extends Component {
  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({
      name: 'excelBulkEditProductDiscountFailModal',
      value: false,
    });
  };

  /**
   * 엑셀 일괄 변경 모달 열기
   */
  openExcelBulkEditProductDiscountModal = () => {
    this.props.toggleModal({
      name: 'excelBulkEditProductDiscount',
      value: true,
    });

    this.closeModal();
  };

  render() {
    const { isOpen, data } = this.props;

    return (
      <ExcelBulkEditProductDiscountFailModal
        isOpen={isOpen}
        data={data}
        openExcelBulkEditProductDiscountModal={this.openExcelBulkEditProductDiscountModal}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.product.excelBulkEditProductDiscountFailModal.isOpen,
    data: state.product.excelBulkEditProductDiscountFailModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: productActions.toggleModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withModal()(ExcelBulkEditProductDiscountFailModalContainer));
